import React, { useCallback } from 'react'
import SpeakerRow from 'components/Users/SpeakerRow'
import { addToCalendarLink } from 'components/VirtualPortal/helpers/calendars'
import _ from 'lodash'

const SessionDescription = ({ state, setState }) => {

  const getSpeakers = useCallback(() => {
    let speakers = []
    _.each(state.session.event_session_speakers, function(speaker){
      speakers.push(<SpeakerRow speaker={speaker} key={speaker.id} />)
    })
    return speakers
  },[state])

  const supportedBrowserPopUp = useCallback(() => {
    const content = `<h4>Supported Browsers</h4>
    <p>Our Peer-to-Peer video conferencing is supported on the following browsers:</p>
    <h5>Windows</h5>
    <p>Chrome, Firefox, Edge (Chromium only, not legacy)</p>
    <h5>Mac</h5>
    <p>Safari 11+, Chrome, Firefox, Edge (Chromium)</p>
    <h5>iOS</h5>
    <p>Safari (iOS 11+)</p>
    <h5>Android</h5>
    <p>Chrome, Firefox</p>
    <h5>Linux</h5>
    <p>Chrome, Firefox</p>`
    setState({ genericModalIsOpen: true, genericModalContent: content, })
  },[])

  const showSessionInformation = useCallback((e) => {
    let element = e.target.closest('.inner-wrapper')
    let computedStyle = window.getComputedStyle(element)
    let topMargin = computedStyle.getPropertyValue('margin-top')
    let state = e.currentTarget.firstElementChild.classList.value.includes('fa-chevron-up')
    setState({ sessionVisible: state })
    let innerWrapper = e.target.closest('.inner-wrapper')
    innerWrapper.style.marginTop = topMargin
  },[state])

  return(
    <div className='container'>
      <div className='inner-wrapper'>
        <div className='session-header'>
          <h5 className='session-type'>{state.session.session_type}</h5>
          <h3 className={'session-name open-' + state.sessionVisible}>{state.session.session_type_key == 'session_type_one_to_one_meeting' ? 'Peer-to-Peer Meetings' : state.session.name}</h3>
        </div>
        <div className={`session-information ${state.sessionVisible ? '' : 'hidden'}`}>
          {state.session.sponsor_name ? <h6>Hosted by {state.session.sponsor_name}</h6> : ''}
          {state.session.event_session_speakers ? getSpeakers(state.session) : ''}
          {state.session.session_type_key == 'session_type_one_to_one_meeting' ?
            state.userDetails.status === 'registration_status_approved' ?
              <div className='session-body'>
                <p>Meet 1-to-1 with peers in your community for in-depth conversations and networking. Please complete the Peer-to-Peer setup to help us match you with like-minded peers.</p>
                <p>Your meetings will be confirmed and will appear here three days prior to the event. You will also receive an email when your meetings are finalized.</p>
                <p><span className='red'>IMPORTANT:</span> Meetings are subject to change; please refresh this page to see the latest updates. Please note that the Peer-to-Peer Meeting platform is only supported on certain browsers.</p>
                <p><a className='psuedo-link' onClick={() => supportedBrowserPopUp()}>View supported browsers</a></p>
              </div>
              : ''
            : <p className='session-body' dangerouslySetInnerHTML={{__html: state.session.body}} ></p>
          }

        </div>
        <div className={'action-links ' + (state.session.session_type_key == 'session_type_one_to_one_meeting' ? 'hide' : '')}>
          <a className='more' onClick={showSessionInformation}><i className={state.sessionVisible ? 'fa fa-chevron-down' : 'fa fa-chevron-up'} ></i> DETAILS</a>
          {addToCalendarLink('agenda', (data) => setState({ ...data }), state )}
        </div>
      </div>
    </div>
  )
}

export default SessionDescription